/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

var props = {
  checkedProps: {
    type: Object
  },
  multiple: Boolean,
  options: {
    type: Array
  },
  uncheckedProps: {
    type: Object
  },
  value: {
    type: Array,
    "default": void 0
  },
  modelValue: {
    type: Array,
    "default": void 0
  },
  defaultValue: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  onChange: Function
};

export { props as default };
//# sourceMappingURL=check-tag-group-props.mjs.map
